// Helper de reCAPTCHA v3.
// Carga el script de Google bajo demanda y genera un token por acción.
// Diseño "graceful": si no hay REACT_APP_RECAPTCHA_SITE_KEY configurada,
// getCaptchaToken devuelve null y el alta sigue funcionando (el backend
// omite la validación cuando tampoco tiene RECAPTCHA_SECRET).

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '';

let scriptPromise = null;

function loadScript() {
  if (!SITE_KEY || typeof window === 'undefined' || typeof document === 'undefined') {
    return Promise.resolve(null);
  }
  if (window.grecaptcha?.execute) return Promise.resolve(window.grecaptcha);
  if (scriptPromise) return scriptPromise;

  scriptPromise = new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(SITE_KEY)}`;
    s.async = true;
    s.defer = true;
    s.onload = () => resolve(window.grecaptcha || null);
    s.onerror = () => {
      scriptPromise = null; // permitir reintento en el próximo submit
      reject(new Error('recaptcha_load_failed'));
    };
    document.head.appendChild(s);
  });
  return scriptPromise;
}

/** ¿Hay site key configurada en el front? */
export function isCaptchaEnabled() {
  return !!SITE_KEY;
}

/** Precarga el script (opcional) para que el token salga rápido al enviar. */
export function preloadCaptcha() {
  loadScript().catch(() => {});
}

/**
 * Genera un token reCAPTCHA v3 para la acción indicada.
 * Devuelve null si no hay site key o si el script no pudo cargar/ejecutar,
 * para no bloquear el envío en entornos sin captcha.
 */
export async function getCaptchaToken(action = 'fabricator_register') {
  console.log('[recaptcha] SITE_KEY:', SITE_KEY ? SITE_KEY.slice(0, 12) + '…' : 'VACÍA');
  if (!SITE_KEY) return null;
  try {
    const grecaptcha = await loadScript();
    console.log('[recaptcha] loadScript result:', grecaptcha, 'window.grecaptcha:', window.grecaptcha);
    if (!grecaptcha) { console.warn('[recaptcha] grecaptcha es null tras loadScript'); return null; }
    await new Promise((res) => grecaptcha.ready(res));
    console.log('[recaptcha] ready OK — execute:', typeof grecaptcha.execute);
    if (typeof grecaptcha.execute !== 'function') { console.warn('[recaptcha] execute no es función'); return null; }
    const token = await grecaptcha.execute(SITE_KEY, { action });
    console.log('[recaptcha] token generado:', token ? token.slice(0, 20) + '…' : 'null');
    return token;
  } catch (err) {
    console.warn('[recaptcha] getCaptchaToken falló:', err);
    return null;
  }
}
